/**
 * Pequeñas Puntadas — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (hero, offer, closing and mobile sticky bar).
 */
export const CHECKOUT_URL = 'https://pequenas-puntadas.impultienda.ar/checkout'

export const PRICE = {
  value: 19900,
  currency: 'ARS',
  label: '$19.900',
  compareAtLabel: '$49.990',
  /** $49.990 → $19.900 = 60,19 % → shown rounded. Savings: $30.090. */
  discountLabel: '60% OFF',
  savingsLabel: 'Ahorrás $30.090',
  /** $19.900 / 31 = $641,94. */
  perModelLead: '31 modelos por $19.900',
  perModelHighlight: 'Menos de $642 por modelo',
  /** 2 × $9.950 = $19.900, no financing surcharge. */
  installmentsLabel: '2 cuotas sin interés de $9.950',
  perModelNote: 'Promedio dentro de la colección completa.',
  note: 'Pago único',
  delivery: 'Después del pago, accedés al enlace de descarga de todos los archivos.',
} as const

export const LAUNCH_LABEL = 'Descuento de lanzamiento'

/** Purchase CTA labels — every one goes to the checkout and shows the same price. */
export const CLOSING_BUY_LABEL = `Quiero los 31 modelos — ${PRICE.label}`
export const OFFER_BUY_LABEL = `Quiero la colección completa — ${PRICE.label}`
